<template>
  <div
    class="border-t border-b border-secondary-50 dark:border-darkblue-600 mt-2 py-2 flex flex-col sm:flex-row sm:items-center"
  >
    <template v-if="hasTags">
      <div
        class="filters-applied flex flex-row flex-nowrap space-x-2 overflow-x-auto w-full min-w-0 sm:flex-1"
      >
        <base-filter-tag-item
          v-for="tag in reversedTags"
          :key="tag[0]"
          :tag="tag"
          @removeTag="removeTag"
        />
      </div>
      <div class="flex flex-row flex-wrap justify-end gap-3 w-full sm:w-auto mt-2 sm:mt-0 sm:ml-4">
        <base-button class="flex-none" @click="saveTags" size="xs" mode="primary-line">
          Guardar búsqueda
        </base-button>
        <base-button class="flex-none" @click="removeAllTags" size="xs" mode="primary-line">
          Borrar filtros
        </base-button>
      </div>
    </template>
    <template v-else>
        <div class="flex h-8 items-center mx-auto">
            <base-icon name="filter" size="sm" class="text-secondary-200" />
            <span class="text-sm text-secondary-600 dark:text-secondary-200">No hay filtros aplicados</span>
        </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'base-table-filter-tags',
  props: {
    tags: {
      type: [Array],
      required: true
    }
  },
  computed: {
    hasTags: function () {
      return this.tags.length > 0
    },
    reversedTags: function () {
      return this.tags.slice().reverse()
    }
  },
  methods: {
    removeTag: function (val) {
      this.$emit('removeTag', val)
    },
    removeAllTags: function () {
      this.$emit('removeAllTags')
    },
    saveTags: function () {
      this.$emit('saveTags')
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-applied > * {
  flex-shrink: 0;
}
.filters-applied > *:first-child {
  margin-left: auto;
}
</style>
